import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { styled as muiStyled } from '@mui/system'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import AppBar from '@mui/material/AppBar'

import GraphControl from '../graphcontrol'

import { BASE_LAYER_LIST } from '../../const/general'

RainGraph.propTypes = {
    // 選択箇所のメシュコード
    latlng : PropTypes.array,
    // 災害ID
    disasterId: PropTypes.string,
    // チェックポイント
    checkpoint: PropTypes.string,
    // アーカイブか否か
    isArchive: PropTypes.bool,
    // シミュレーションID
    simulationId: PropTypes.string,
    // シミュレーションか否か
    isSimulation: PropTypes.bool,
}

const GraphWrapper = styled.div`
    height: calc(40vh - 30px - 2.5rem);
    margin: 0.5rem 0;
`

const StyleTabs = muiStyled(Tabs)(({ theme }) => ({
    minHeight: '32px',
    height: '32px',
    backgroundColor: '#152451',
    color: '#FFFFFF',
    arignItems: 'center',
}))
const StyleTab = muiStyled(Tab)(({ theme }) => ({
    minHeight: '32px',
    height: '32px',
    backgroundColor: '#152451',
    color: '#FFFFFF',
    arignItems: 'center',
    fontSize: '18px',
    fontWeight: 'bold',
    "&:hover": {
        backgroundColor: '#223C6D',
    },
}))


/**
 * グラフのIDとクラス名を取得する
 * @param {string} index 値の種類
 * @returns {object}
 */
function allyProps(index){
    return {
        id: `graph-tap-${index}`,
        'aria-controls' : `graph-tap-${index}`,
    };
}

/**
 * 雨量グラフ
 * @param {array} latlng 緯度経度
 * @param {string} disasterId 災害ID
 * @param {string} checkpoint チェックポイント時間
 * @param {bool} isArchive アーカイブか否か
 * @param {bool} isSimulation シミュレーションか否か
 * @param {string} simulationId シミュレーションID
 * @returns {JSX.Element}
 */
export default function RainGraph(props){
    const { latlng, disasterId='', checkpoint='', isArchive=false, simulationId='', isSimulation=false, selectedCategory, setSelectedCategory} = props
    const handleChange = (event, newValue) => {
        setSelectedCategory(BASE_LAYER_LIST.find(p => p.category === newValue))
    }


    return(
        <GraphWrapper>
            <AppBar position='static'>
                <StyleTabs
                    value={selectedCategory.category}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable force tabs"
                    TabIndicatorProps={{
                        style: {
                        backgroundColor: "#318AB7"
                        }
                    }}
                >
                {
                    BASE_LAYER_LIST.map((elem, i) =>
                        <StyleTab
                            key={i.toString()}
                            value={elem.category}
                            label={elem.name}
                            {...allyProps(elem.category)}
                        />
                    )
                }
                </StyleTabs>
            </AppBar>
            {
                BASE_LAYER_LIST.map((elem, i) =>
                    <GraphControl
                        key={elem.category}
                        chooseCategory={selectedCategory.category}
                        category={elem.category}
                        latlng={latlng}
                        info={elem}
                        disasterId={disasterId}
                        checkpoint={checkpoint}
                        isArchive={isArchive}
                        simulationId={simulationId}
                        isSimulation={isSimulation}
                    />
                )
            }
        </GraphWrapper>
    )

}
